// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const IdeaRef = zod.object({
  "id": zod.uuid(),
  "title": zod.string()
});

export type IdeaRef = zod.input<typeof IdeaRef>;
export type IdeaRefOutput = zod.output<typeof IdeaRef>;
